/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreatePayTypeData,
  CreatePayTypeResponse,
  ListPayTypesResponse,
  ShowPayTypeResponse,
  UpdatePayTypeData,
  UpdatePayTypeResponse,
} from '../models/index';
import {
    CreatePayTypeDataFromJSON,
    CreatePayTypeDataToJSON,
    CreatePayTypeResponseFromJSON,
    CreatePayTypeResponseToJSON,
    ListPayTypesResponseFromJSON,
    ListPayTypesResponseToJSON,
    ShowPayTypeResponseFromJSON,
    ShowPayTypeResponseToJSON,
    UpdatePayTypeDataFromJSON,
    UpdatePayTypeDataToJSON,
    UpdatePayTypeResponseFromJSON,
    UpdatePayTypeResponseToJSON,
} from '../models/index';

export interface CreatePayTypeRequest {
    createPayTypeData?: CreatePayTypeData;
}

export interface DeletePayTypeRequest {
    id: number;
}

export interface ShowPayTypeRequest {
    id: number;
}

export interface UpdatePayTypeRequest {
    id: number;
    updatePayTypeData?: UpdatePayTypeData;
}

/**
 * 
 */
export class PayTypesApi extends runtime.BaseAPI {

    /**
     * Create a new Pay Type
     * Create Pay Type
     */
    async createPayTypeRaw(requestParameters: CreatePayTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePayTypeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.pay-types.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pay-types`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePayTypeDataToJSON(requestParameters['createPayTypeData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePayTypeResponseFromJSON(jsonValue));
    }

    /**
     * Create a new Pay Type
     * Create Pay Type
     */
    async createPayType(requestParameters: CreatePayTypeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePayTypeResponse> {
        const response = await this.createPayTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a pay type by the given Id.
     * Delete Pay Type
     */
    async deletePayTypeRaw(requestParameters: DeletePayTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deletePayType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.pay-types.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pay-types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a pay type by the given Id.
     * Delete Pay Type
     */
    async deletePayType(requestParameters: DeletePayTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePayTypeRaw(requestParameters, initOverrides);
    }

    /**
     * List all pay types for your company.
     * List Pay Types
     */
    async listPayTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPayTypesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.pay-types.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pay-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPayTypesResponseFromJSON(jsonValue));
    }

    /**
     * List all pay types for your company.
     * List Pay Types
     */
    async listPayTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPayTypesResponse> {
        const response = await this.listPayTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Show details of a specific pay type.
     * Show Pay Type
     */
    async showPayTypeRaw(requestParameters: ShowPayTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowPayTypeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showPayType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.pay-types.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pay-types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowPayTypeResponseFromJSON(jsonValue));
    }

    /**
     * Show details of a specific pay type.
     * Show Pay Type
     */
    async showPayType(requestParameters: ShowPayTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowPayTypeResponse> {
        const response = await this.showPayTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing pay type
     * Update Pay Type
     */
    async updatePayTypeRaw(requestParameters: UpdatePayTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdatePayTypeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePayType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.pay-types.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/pay-types/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePayTypeDataToJSON(requestParameters['updatePayTypeData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdatePayTypeResponseFromJSON(jsonValue));
    }

    /**
     * Update an existing pay type
     * Update Pay Type
     */
    async updatePayType(requestParameters: UpdatePayTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdatePayTypeResponse> {
        const response = await this.updatePayTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
